import React, { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, Spinner } from "reactstrap";
import { Link } from "react-router-dom";
import { useGetBranches } from "hooks/useBranches";
import { useDispatch } from "react-redux";
import { useSelector } from "hooks/useSelector";
import { RootState } from "slices";
import "./BranchDropdown.scss";
import { setBranchInfo } from "slices/branch/reducer";

const BranchDropdown = () => {
  const [branchDrp, setBranchDrp] = useState(false);
  const { data: branches, isLoading } = useGetBranches();
  const dispatch = useDispatch();
  const selectedBranch = useSelector(
    (state: RootState) => state.branch.currentBranch
  );

  const handleBranchSelect = (branch) => {
    dispatch(setBranchInfo(branch));
    setBranchDrp(false);
  };

  return (
    <div className="branch-wrapper">
      <Dropdown
        className="branch-dropdown"
        isOpen={branchDrp}
        toggle={() => setBranchDrp(!branchDrp)}
      >
        <DropdownToggle className="btn branch-selector" tag="button">
          <div className="d-flex align-items-center">
            <i className="bx bx-store-alt me-2" />
            <span className="branch-name">
              {selectedBranch?.name || "Select Branch"}
            </span>
            <i className="bx bx-chevron-down ms-2" />
          </div>
        </DropdownToggle>
        <DropdownMenu className="branch-menu">
          <div className="branch-menu-header">
            <h6 className="mb-0">Select Branch</h6>
          </div>
          <div className="branch-menu-content">
            {isLoading ? (
              <div className="text-center p-3">
                <Spinner size="sm" color="primary" />
              </div>
            ) : (
              <>
                <Link
                  key={0}
                  className={`branch-item ${
                    selectedBranch?.id === "" ? "active" : ""
                  }`}
                  to="#"
                  onClick={() => handleBranchSelect("")}
                >
                  {/* TODO: hide all branches in branch settings */}
                  <i className="bx bx-building-house me-2" />
                  <span>All branches</span>
                  {selectedBranch?.id === "" && (
                    <i className="bx bx-check ms-auto" />
                  )}
                </Link>
                {branches?.map((branch) => (
                  <Link
                    key={branch.id}
                    className={`branch-item ${
                      selectedBranch?.id === branch.id ? "active" : ""
                    }`}
                    to="#"
                    onClick={() => handleBranchSelect(branch)}
                  >
                    <i className="bx bx-building-house me-2" />
                    <span>{branch.name}</span>
                    {selectedBranch?.id === branch.id && (
                      <i className="bx bx-check ms-auto" />
                    )}
                  </Link>
                ))}
              </>
            )}
          </div>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default BranchDropdown;
